import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';

export const RESET_ROSREESTR_DATA = 'ROSREESTR_DATA :: RESET';

export type TResetRosreestrDataAction = IReduxAction<typeof RESET_ROSREESTR_DATA>;

export const resetRosreestrData = actionGenerator<typeof RESET_ROSREESTR_DATA>(RESET_ROSREESTR_DATA);
